import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css, cx} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {parseSearch} from "@pg-mono/request";
import {safelyParsePage} from "@pg-mono/string-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {getPromotionListingDescription, getPromotionListingHeadingHighlight, getPromotionListingHeadingSuffix} from "../../helpers/promotion_listing_config";
import {PromotionListSearchFilter} from "./filters/PromotionListSearchFilter";

interface IProps {
    className?: string;
}
export const PromotionListHeader = (props: IProps) => {
    const location = useLocation();
    const promotionType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type);
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const query = parseSearch(location.search);
    const page = safelyParsePage(query.page);
    const pageString = page > 1 ? ` - strona ${page}` : undefined;
    const showDescription = page === 1 && !region;
    const headingHighlight = getPromotionListingHeadingHighlight(promotionType);
    const headingSuffix = getPromotionListingHeadingSuffix({type: promotionType, regionName: region?.short_name});
    const description = showDescription ? getPromotionListingDescription(promotionType) : null;

    return (
        <div className={cx(promotionListHeader, !showDescription && promotionListHeaderWithoutDescriptionStyle, props.className)}>
            <SeoMainHeadline as="h1" variant="headline_2" pageString={pageString} suffixContent={pageString} className={headlineStyle}>
                <Highlight>{headingHighlight}</Highlight> {headingSuffix.trim()}
            </SeoMainHeadline>

            {showDescription && (
                <Text variant="body_copy_2" as="p" className={descriptionStyle}>
                    {description}
                </Text>
            )}

            <div className={searchWrapperStyle}>
                <PromotionListSearchFilter />
            </div>
        </div>
    );
};

const promotionListHeader = css({
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gridTemplateAreas: `
        "title"
        "description"
        "search"
    `,
    rowGap: 2,

    md: {
        gridTemplateColumns: "minmax(0, 1fr) minmax(28rem, 40.7rem)",
        gridTemplateAreas: `
            "title search"
            "description description"
        `,
        alignItems: "start",
        columnGap: 2
    }
});

const promotionListHeaderWithoutDescriptionStyle = css({
    gridTemplateAreas: `
        "title"
        "search"
    `,

    md: {
        gridTemplateAreas: `
            "title search"
        `
    }
});

const headlineStyle = css({
    gridArea: "title",
    m: 0,
    color: "var(--colors-secondary)",
    minWidth: 0
});

const descriptionStyle = css({
    gridArea: "description",
    m: 0,
    maxWidth: "100%",
    color: "var(--colors-gray-800)"
});

const searchWrapperStyle = css({
    gridArea: "search",
    width: "100%",
    md: {
        justifySelf: "stretch"
    }
});
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css, cx} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {parseSearch} from "@pg-mono/request";
import {safelyParsePage} from "@pg-mono/string-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {getPromotionListingDescription, getPromotionListingHeadingHighlight, getPromotionListingHeadingSuffix} from "../../helpers/promotion_listing_config";
import {PromotionListSearchFilter} from "./filters/PromotionListSearchFilter";

interface IProps {
    className?: string;
}
export const PromotionListHeader = (props: IProps) => {
    const location = useLocation();
    const promotionType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type);
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const query = parseSearch(location.search);
    const page = safelyParsePage(query.page);
    const pageString = page > 1 ? ` - strona ${page}` : undefined;
    const showDescription = page === 1 && !region;
    const headingHighlight = getPromotionListingHeadingHighlight(promotionType);
    const headingSuffix = getPromotionListingHeadingSuffix({type: promotionType, regionName: region?.short_name});
    const description = showDescription ? getPromotionListingDescription(promotionType) : null;

    return (
        <div className={cx(promotionListHeader, !showDescription && promotionListHeaderWithoutDescriptionStyle, props.className)}>
            <SeoMainHeadline as="h1" variant="headline_2" pageString={pageString} suffixContent={pageString} className={headlineStyle}>
                <Highlight>{headingHighlight}</Highlight> {headingSuffix.trim()}
            </SeoMainHeadline>

            {showDescription && (
                <Text variant="body_copy_2" as="p" className={descriptionStyle}>
                    {description}
                </Text>
            )}

            <div className={searchWrapperStyle}>
                <PromotionListSearchFilter />
            </div>
        </div>
    );
};

const promotionListHeader = css({
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gridTemplateAreas: `
        "title"
        "description"
        "search"
    `,
    rowGap: 2,

    md: {
        gridTemplateColumns: "minmax(0, 1fr) minmax(28rem, 40.7rem)",
        gridTemplateAreas: `
            "title search"
            "description description"
        `,
        alignItems: "start",
        columnGap: 2
    }
});

const promotionListHeaderWithoutDescriptionStyle = css({
    gridTemplateAreas: `
        "title"
        "search"
    `,

    md: {
        gridTemplateAreas: `
            "title search"
        `
    }
});

const headlineStyle = css({
    gridArea: "title",
    m: 0,
    color: "var(--colors-secondary)",
    minWidth: 0
});

const descriptionStyle = css({
    gridArea: "description",
    m: 0,
    maxWidth: "100%",
    color: "var(--colors-gray-800)"
});

const searchWrapperStyle = css({
    gridArea: "search",
    width: "100%",
    md: {
        justifySelf: "stretch"
    }
});
